"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function toggleOnClick(action, value) {
  return function (event) {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    action(value);
  };
}

exports.toggleOnClick = toggleOnClick;

function rawFileInputChangeToHandler(handler) {
  return function (e) {
    var files = e.target.files;

    if (files && files.length > 0) {
      var file = files.item(0);

      if (file != null) {
        handler(file);
      } else {
        throw new Error('File object on HTML input event was null');
      }
    } else {
      throw new Error('No file found on HTML input event');
    }
  };
}

exports.rawFileInputChangeToHandler = rawFileInputChangeToHandler;